export function tabs() {
  const tabGroups = document.querySelectorAll(".tabs");

  tabGroups.forEach((group) => {
    const tabButtons = group.querySelectorAll(".tab-button");
    const tabContents = group.querySelectorAll(".tab-content");
    const tabImages = group.querySelectorAll(".tab-image");

    tabButtons.forEach((button) => {
      button.addEventListener("click", () => {
        tabButtons.forEach((btn) => btn.classList.remove("active"));
        tabContents.forEach((content) => content.classList.remove("active"));
        tabImages.forEach((image) => image.classList.remove("active"));

        button.classList.add("active");

        const tabId = button.getAttribute("data-tab");
        const tabContent = group.querySelector("#content-" + tabId);
        const tabImage = group.querySelector("#image-" + tabId);
        if (tabContent) tabContent.classList.add("active");
        if (tabImage) tabImage.classList.add("active");
      });
    });
  });
}
